// extracted by mini-css-extract-plugin
module.exports = {"article":"DifferenceBlocks_article__IwBPC","heading":"DifferenceBlocks_heading__RWGv1","tagline":"DifferenceBlocks_tagline__PD1nK","subtitle":"DifferenceBlocks_subtitle__8U13C"};